var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollegeType2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m360 90h-90l-10-45 10-45h90z",
    fill: "#19ae8f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240 0v120l7.5 10 7.5-10 10-60-10-60z",
    fill: "#cdf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 228.289v281.711h120l10-152.106-10-159.605z",
    fill: "#3e4665"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m270 0h-15v120l7.5 10 7.5-10z",
    fill: "#adc9f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120 150v360h60l75-150 37.5-105-37.5-105-67.5-10z",
    fill: "#4e5f7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m390 198.289-10 168.711 10 143h120v-281.711z",
    fill: "#2e2f4c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m390 150-67.5-10-67.5 10v209.999l75 150.001h60z",
    fill: "#3e4665"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ffdf40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m50 285h30v30h-30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50 345h30v30h-30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50 405h30v30h-30z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m430 285h30v30h-30z",
    fill: "#ffbe40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m430 345h30v30h-30z",
    fill: "#ffbe40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m430 405h30v30h-30z",
    fill: "#ffbe40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m180 180h30v30h-30z",
    fill: "#ffdf40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m180 240h30v30h-30z",
    fill: "#ffdf40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m180 300h30v30h-30z",
    fill: "#ffdf40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m300 180h30v30h-30z",
    fill: "#ffbe40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m300 240h30v30h-30z",
    fill: "#ffbe40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m300 300h30v30h-30z",
    fill: "#ffbe40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90 120v30h165l10-15-10-15z",
    fill: "#ff6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 120h165v30h-165z",
    fill: "#ea1c81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m180 360v150h30l45-120 10-15-10-15z",
    fill: "#3e4665"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 360h75v150h-75z",
    fill: "#2e2f4c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m210 390v120h45l10-60-10-60z",
    fill: "#66e6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 390h45v120h-45z",
    fill: "#59c2ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240 180v30h15l10-15-10-15z",
    fill: "#ffdf40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 180h15v30h-15z",
    fill: "#ffbe40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240 270h15l10-15-10-15h-15z",
    fill: "#ffdf40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 240h15v30h-15z",
    fill: "#ffbe40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240 330h15l10-15-10-15h-15z",
    fill: "#ffdf40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 300h15v30h-15z",
    fill: "#ffbe40"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollegeType2);
export default __webpack_public_path__ + "static/media/collegeType-2.5f45bc1e32a76d4a4059584f3408cd6d.svg";
export { ForwardRef as ReactComponent };